import script from "./ProjectsBeplanet.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsBeplanet.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsBeplanet.vue?vue&type=style&index=0&id=481dae54&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-481dae54"]])

export default __exports__